import { render, staticRenderFns } from "./M2hLocaleChanger.vue?vue&type=template&id=0c8c9b56&"
import script from "./M2hLocaleChanger.vue?vue&type=script&lang=js&"
export * from "./M2hLocaleChanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports